export default {
  partner_id: 1954,
  domain: 'https://luxoft.sailplay.com',
  lang: 'en',
  profile_redirect_url: 'http://example.com',

  // This is default values
  remote_config_name: 'default',
  // stores_url: 'stores.json'
}
